<template>
  <div class="home">
    <div class="top-white-box"></div>
    <div class="top-gray-box">
      <h1>Lists</h1>
    </div>
    <GiveawayBox />
    <Articles />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import Articles from '@/components/Articles.vue'
import GiveawayBox from '@/components/GiveawayBox.vue'
import settings from '@/settings'

export default defineComponent({
  name: 'blog',
  components: {
    Articles,
    GiveawayBox
  },
  setup() {
    onMounted(() => {
      document.title = `${settings.siteNameCaps} | ${settings.siteNameCaps} Blog. Read all about deals on our product oriented blog.`
    })

    return {
      settings
    }
  }
})
</script>